import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store'
import Vuex from 'vuex'
import VueCarousel from 'vue-carousel'
import { VueTyper } from 'vue-typer'
import VueTyperPlugin from 'vue-typer'
import VueFire from 'vuefire'
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueDraggable from 'vue-draggable'
import '@google/model-viewer'
import * as THREE from 'three'
Vue.use(THREE)



// Pulling firebase/firestore information from firebase.js in ../config/firebase
import { firestoreInit, authorization, db } from '../config/firebase'

// Temporarily exporting firestore & auth so that the rest of the components within the app still work
export const firestore = firestoreInit
export const auth = authorization
export const database = db

// ..
AOS.init({offset: 300})

Vue.config.productionTip = false
Vue.use(VueCarousel)
Vue.use(VueTyperPlugin)
Vue.use(VueFire)
Vue.use(VueDraggable)
Vue.use(Vuex)


// Card filter
Vue.filter('cardType', type => {
  return type === 'BP' ? `Balance Paid` : type === 'BR' ? `Balance Reminder` : type === 'AR' ? `Appointment Request` : type === 'UA' ? `Upcoming Appointment` : type === 'SA' ? `Scheduled Appointment` : type === 'AM' ? `Appointment Modification` : type === 'MA' ? `New Media Added` : type === 'UI' ? `Updated Information` : type === 'NM' ? `New Message` : type === 'GI' ? `General Information` : type === 'UP' ? `Update` : type === 'PR' ? `Promotions` : type === 'FR' ? `Financial Reminder` : type === 'INS' ? `Insurance` : type === 'EOB' ? `Explanation of benifits` : type === 'EOY' ? `End-of-Year` : type === 'OB' ? `Outstanding Balance` : type === 'RX' ? `Prescriptions` : `N/a`
})

// Card filter
Vue.filter('cardColor', type => {
  return type === 'BP' ? `bg-1` : type === 'BR' ? `bg-3` : type === 'AR' ? `bg-4` : type === 'UA' ? `bg-1` : type === 'SA' ? `bg-2` : type === 'AM' ? `bg-3` : type === 'MA' ? `bg-4` : type === 'UI' ? `bg-5` : type === 'NM' ? `bg-6` : type === 'GI' ? `bg-7` : type === 'UP' ? `bg-8` : type === 'PR' ? `bg-9` : type === 'FR' ? `bg-10` : type === 'INS' ? `bg-11` : type === 'EOB' ? `bg-12` : type === 'EOY' ? `bg-13` : type === 'OB' ? `bg-14` : type === 'RX' ? `bg-15` : `N/a`
})

const settings = {timestampsInSnapshots: true}

firestore.settings(settings)

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js